import React from 'react'

const NotYetCertifiedCard = ({ large }) => {
    return (
        <div style={{
            border: '2px solid #131313',
            borderRadius: '0.75rem',
            padding: large ? '12px 8px' : '2px 8px',
            backgroundColor: '#FEFEFE',
            width: large ? '105px' : '70px',
            height: large ? '125px' : '80px',
            marginTop: large ? '3px' : '0px',
        }}>
            <div className='df aic jcc mt0-25rem'>
                <img
                    src={require('../../../../../../images/checklist-logo.webp')}
                    style={{
                        width: large ? "22px" : "20px",
                        height: large ? "18px" : "17px"
                    }}
                    alt="none"
                />
            </div>
            <h3 className='w100 tac mb0-5rem' style={{ lineHeight: '1.2', color: '#2D2D2D', marginTop: large ? '.85rem' : '8px', fontSize: large ? '14px' : '9px' }}>Not Yet <br></br> Certified</h3>
            <p className='w100 tac mb0-25rem' style={{ color: '#1C1A1AB2', fontSize: '7px', marginTop: large ? '1.23rem' : '0px' }}>Unaudited</p>
        </div>
    )
}

export default NotYetCertifiedCard